import $ from 'jquery';
import Toggle from './modules/toggle';
import Select from './modules/select';
import initPlugins from './core/init.plugins';

new Toggle('.js-toggle');
new Select('.js-select');

initPlugins();




// WEBPACK FOOTER //
// ./app.js